import { useState } from "react";
import { Button } from "react-bootstrap";
import { handleGenerarActa } from "./handlers";
import { MuniSpinner2 } from "../../../../components";
import { PDFIcon } from "../../../../components/Icons";
import useActas from "../../../../api/actas";

const GenerarActa = (props) => {
  const { acta, setActaDetalle} = props;
  const [isLoading, setIsLoading] = useState(false);
  const [pdf, setPdf] = useState(null);
  const { generarActa } = useActas()

  return (
    <div>
      <Button
        size="lg"
        className="w-100"
        onClick={() => {
          generarActa(setPdf)
          // handleGenerarActa(acta, setActa, setPdf, setArchivos, setIsLoading);
        }}
        disabled={isLoading}
      >
        {isLoading ? (
          <MuniSpinner2
            width="22px"
            height="22px"
            circularProgressSize={30}
            circularProgressColor="#ffffff"
            fileName="bola-blanca.png"
          />
        ) : (
          <span>
            <PDFIcon /> Generar acta física
          </span>
        )}
      </Button>
      {pdf && (
        <a
          href={pdf}
          download={`${acta.dependencia}-${acta.numero_acta}-fisica`}
          className="text-center mt-3 d-block"
          style={{ border: "2px #1334c9 dashed" }}
        >
          DESCARGAR ACTA PARA IMPRESIÓN
        </a>
      )}
    </div>
  );
};

export default GenerarActa;
